import React from 'react';

import Text from '../../shared/Typography';
import CodeBlock from './CodeBlock';

/* eslint-disable */
const Typography = () => {
  return (
    <React.Fragment>
      <Text h2 className='pattern-library__title'>Typography</Text>
      <CodeBlock>some code / info about this component</CodeBlock>

      <Text h1 icon='eye-open' iconSize='medium' className='pattern-library__title'>Harry Potter and the Prisoner of Azkaban</Text>
      <Text h2 icon='eye-close' iconSize='medium' className='pattern-library__title'>Harry Potter and the Prisoner of Azkaban</Text>
      <Text h3 icon='cal' iconSize='small' className='pattern-library__title'>Harry Potter and the Prisoner of Azkaban</Text>
      <Text link icon='steth' iconSize='small' className='pattern-library__title'>Harry Potter and the Prisoner of Azkaban</Text>
      <Text
        paragraph
        align='left'
        className='pattern-library__title'
        hasSubtitle
        icon='face'
        iconSize='medium'
        truncated>
        A paragraph with all the props! Im not going to be murdered Harry said out loud  Thats the spirit dear said his mirror sleepily Yer a wizard Harry The wand chooses the wizard How very irritating I think Ill just go and have Of course it is happening inside your head Harry but why on earth should that mean it is not real Theres no need to call 
      </Text>
    </React.Fragment>
  );
};

export default Typography;
/* eslint-enable */


// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/typography.js